// All 36 Nigerian states plus the FCT — the "Filter By" state options on the
// public pages always list every state, even where the placeholder data
// only covers a few of them.
export const NIGERIA_STATES = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 'Borno',
  'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 'FCT', 'Gombe', 'Imo',
  'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara', 'Lagos', 'Nasarawa',
  'Niger', 'Ogun', 'Ondo', 'Osun', 'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara',
];

export const STATE_FILTER_OPTIONS = ['All States', ...NIGERIA_STATES];

// State-capital coordinates — where a facility has no exact lat/lng of its
// own, its map view pins its state's capital instead
export const STATE_CAPITAL_COORDS = {
  Abia: [5.5320, 7.4860], Adamawa: [9.2035, 12.4954], 'Akwa Ibom': [5.0377, 7.9128], Anambra: [6.2104, 7.0741],
  Bauchi: [10.3158, 9.8442], Bayelsa: [4.9267, 6.2676], Benue: [7.7337, 8.5214], Borno: [11.8333, 13.1500],
  'Cross River': [4.9757, 8.3417], Delta: [6.2059, 6.6959], Ebonyi: [6.3249, 8.1137], Edo: [6.3350, 5.6037],
  Ekiti: [7.6211, 5.2214], Enugu: [6.4584, 7.5464], FCT: [9.0765, 7.3986], Gombe: [10.2897, 11.1673],
  Imo: [5.4850, 7.0350], Jigawa: [11.7562, 9.3388], Kaduna: [10.5105, 7.4165], Kano: [12.0022, 8.5920],
  Katsina: [12.9908, 7.6018], Kebbi: [12.4539, 4.1975], Kogi: [7.8023, 6.7333], Kwara: [8.4966, 4.5421],
  Lagos: [6.6018, 3.3515], Nasarawa: [8.4939, 8.5153], Niger: [9.6139, 6.5569], Ogun: [7.1475, 3.3619],
  Ondo: [7.2508, 5.2103], Osun: [7.7719, 4.5624], Oyo: [7.3775, 3.9470], Plateau: [9.8965, 8.8583],
  Rivers: [4.8156, 7.0498], Sokoto: [13.0059, 5.2476], Taraba: [8.8937, 11.3601], Yobe: [11.7470, 11.9608],
  Zamfara: [12.1704, 6.6641],
};
